import { TokenData } from "../entities";

export class LoginHelper {
    static validateForm(username: string, password: string): boolean {
        return username.length > (process.env.NX_USERNAME_LENGTH || 6)
         && password.length > (process.env.NX_PASSWORD_LENGTH || 6);
    }

    static validateToken(): boolean {
        const token = JSON.parse(localStorage.getItem('user-token'));
        if (!token) {
            return false;
        }
        if (+new Date() > token.expiresAt) {
            localStorage.removeItem('user-token');
            return false;
        }
        return true;
    }

    static storeToken(tokenData: TokenData): void {
        tokenData.expiresAt = +new Date() + +tokenData.expiresIn.split(' ')[0] * 31556952000;
        localStorage.setItem('user-token', JSON.stringify(tokenData));
    }

    static logout(): void {
        localStorage.removeItem('user-token');
        window.location.reload();
    }
}